module.exports = __webpack_public_path__ + "static/Ai-86a2e7a089ce2705b0ad9ea22d640968.png";